import React from "react";

export default function IconArrowUp() {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.08331 4.66667L4.99998 1.75M4.99998 1.75L7.91665 4.66667M4.99998 1.75V9.25"
        stroke="#"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
